import { Box, Skeleton, Text } from '@chakra-ui/react'

export const AiOperatorCriteriaLoader = () => {
  return (
    <Box mb={6} width='100%'>
      <Text fontSize='16px' fontWeight='medium' letterSpacing='-0.8px' mb={2}>
        AI Operator Criteria
      </Text>
      <Text color='gray.600' fontSize='sm' mb={4}>
        Loading available criteria...
      </Text>
      <Skeleton borderRadius='10px' height='60px' mb={2} />
      <Skeleton borderRadius='10px' height='60px' mb={2} />
      <Skeleton borderRadius='10px' height='60px' mb={2} />
    </Box>
  )
}
